import type { PropsWithChildren } from 'react';

import { default as styled } from 'styled-components';

import { config } from '@/config';

// Because of e2e tests.
const CameraPlaceholder = styled.div`
  height: 500px;
`;

export const CaptureWrapper = ({ children }: PropsWithChildren) => {
  if (config.cameraDisabled) {
    return <CameraPlaceholder />;
  }

  return <>{children}</>;
};
